let redirectUri = 'https://biddingza-i.bmwgroup.com';
let clientId = '933c314b-8d47-460f-a786-e39fc8f9a665';

if (typeof window !== 'undefined' && window.location.hostname.endsWith('.net')) {
  redirectUri = 'https://biddingza-i.bmwgroup.net';
  clientId = 'b591567d-858e-4906-97c9-73f9f1bf4a83';
}

export const AuthConfig = {
  AMBaseURL: 'https://emea.int.alpha.sso.bmwgroup.com/auth',
  realmPath: 'realms/root/realms/alpha',
  clientId,
  redirectUri,
  state: 'myappstate',
  nonce: '123456789',
  scopes: 'openid%20profile%20email%20organization',
};

export const environment = {
  externalLinks: {
    unitOverview: 'https://overview-ui.bmwgroup.com?vin=',
  },
};
